/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 */
/* KGS - Product Thumbnail Click */
(function () {

  function initKGSThumbnails() {

    document.querySelectorAll('.Product__Gallery--withThumbnails').forEach(function (gallery) {

      var slideshow = gallery.querySelector('.Product__Slideshow');

      if (!slideshow || typeof Flickity === 'undefined') {
        return;
      }

      var flickity = Flickity.data(slideshow);

      if (!flickity) {
        return;
      }

      var thumbnails = gallery.querySelectorAll(
        '.Product__SlideshowNav--thumbnails .Product__SlideshowNavImage'
      );

      thumbnails.forEach(function (thumbnail) {

        if (thumbnail.dataset.kgsThumbnailReady === 'true') {
          return;
        }

        thumbnail.dataset.kgsThumbnailReady = 'true';

        thumbnail.addEventListener('click', function (event) {

          event.preventDefault();

          var targetId = thumbnail.getAttribute('href');

          if (!targetId) {
            return;
          }

          targetId = targetId.substring(1);

          var targetSlide = document.getElementById(targetId);

          if (!targetSlide) {
            return;
          }

          var cells = flickity.getCellElements();
          var slideIndex = cells.indexOf(targetSlide);

          if (slideIndex !== -1) {
            flickity.select(slideIndex);

            thumbnails.forEach(function (item) {
              item.classList.remove('is-selected');
            });

            thumbnail.classList.add('is-selected');
          }

        });

      });

    });

  }

  document.addEventListener('DOMContentLoaded', function () {
    setTimeout(initKGSThumbnails, 1000);
  });

  window.addEventListener('load', function () {
    setTimeout(initKGSThumbnails, 1000);
  });

  document.addEventListener('shopify:section:load', function () {
    setTimeout(initKGSThumbnails, 500);
  });

})();